export default () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.89536 3.43472C2.38925 4.94104 2.38981 7.383 3.89605 8.88924C4.29415 9.28728 4.758 9.57858 5.25226 9.76622C4.84891 16.3086 10.6618 21.3579 16.8864 20.3756C17.0164 20.5632 17.1639 20.7429 17.3311 20.9101C18.8373 22.4161 21.2787 22.4161 22.7849 20.9101C24.2912 19.4038 24.2917 16.9619 22.7856 15.4555C21.2793 13.9492 18.8367 13.9492 17.3304 15.4555C16.6377 16.1483 16.2645 17.039 16.209 17.9456C11.6158 18.4845 7.41148 14.7027 7.7513 9.84978C8.33626 9.67136 8.88725 9.35182 9.34989 8.88924C10.8561 7.383 10.8567 4.94104 9.35058 3.43472C7.84427 1.92841 5.40167 1.92841 3.89536 3.43472ZM19.0001 17.1252C19.5842 16.5411 20.5318 16.5411 21.1159 17.1252C21.6998 17.7094 21.6993 18.6563 21.1152 19.2403C20.5311 19.8242 19.5849 19.8242 19.0008 19.2403C18.4167 18.6563 18.4162 17.7094 19.0001 17.1252ZM5.56507 5.10443C6.14919 4.52031 7.09675 4.52031 7.68087 5.10443C8.26479 5.68856 8.26423 6.63548 7.68018 7.21953C7.09611 7.80338 6.14983 7.80338 5.56576 7.21953C4.98171 6.63548 4.98116 5.68856 5.56507 5.10443Z"
      fill="currentColor"
    />
  </svg>
);
